var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "animated fadeIn" }, [
    !_vm.group.id
      ? _c("div", [
          _c("p", [
            _vm._v(
              "group not found, or you do not have access to this group in the given Org/Group context."
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.group.id
      ? _c(
          "div",
          { staticClass: "personPage" },
          [
            _c(
              "b-row",
              { staticClass: "mb-3", attrs: { "align-h": "between" } },
              [
                _c("b-col", { attrs: { cols: "auto" } }, [
                  _c("h4", { staticClass: "card-title mb-0" }, [
                    _vm._v(_vm._s(_vm.group.groupName))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "small text-muted" }, [
                    _vm._v("Added " + _vm._s(_vm.getGroupAddedDate()))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "auto" } },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: { to: "/admin/groups/" + _vm.group.id + "/edit" }
                      },
                      [
                        _c("b-button", { staticClass: "mx-0" }, [
                          _vm._v("Edit")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { sm: "8" } }, [
                  _c(
                    "div",
                    [
                      _c(
                        "b-card",
                        { attrs: { "no-body": "" } },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "header" }, slot: "header" },
                            [_c("strong", [_vm._v("Information")])]
                          ),
                          _vm._v(" "),
                          _c("b-card-body", [
                            _c("div", { staticClass: "pb-4" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "mb-0 text-muted text-uppercase font-weight-bold"
                                },
                                [_vm._v("ID")]
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("h4", [_vm._v(_vm._s(_vm.group.id))])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "pb-4" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "mb-0 text-muted text-uppercase font-weight-bold"
                                },
                                [_vm._v("Group Name")]
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("h4", [_vm._v(_vm._s(_vm.group.groupName))])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "pb-4" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "mb-0 text-muted text-uppercase font-weight-bold"
                                },
                                [_vm._v("Is Owning Group")]
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("h4", [
                                _vm._v(_vm._s(_vm.group.isOwningGroup))
                              ])
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { sm: "4" } },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "12" } },
                          [
                            _c("GroupOrganizations", {
                              attrs: {
                                memberOrganizations: _vm.group.memberOrgs,
                                groupId: _vm.groupId,
                                defaultOrg: _vm.defaultGroupId,
                                groupName: _vm.group.groupName
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "12" } },
                          [
                            _c(
                              "b-card",
                              { attrs: { "no-body": "" } },
                              [
                                _c("b-card-header", [
                                  _c("b", [_vm._v("Meta")])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "b-list-group",
                                  { attrs: { flush: "" } },
                                  [
                                    _c(
                                      "b-list-group-item",
                                      { staticClass: "small text-muted" },
                                      [
                                        _c("b", [_vm._v("Created At: ")]),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.getCreatedAt()) +
                                            "\n                  "
                                        ),
                                        _vm._.isObject(_vm.group.createdBy)
                                          ? _c("div", [
                                              _c("b", [_vm._v(" by: ")]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._.get(
                                                      _vm.group,
                                                      "createdBy.emailAddress",
                                                      ""
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-list-group-item",
                                      { staticClass: "small text-muted" },
                                      [
                                        _c("b", [_vm._v("Last Updated: ")]),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.getLastUpdateDate()) +
                                            "\n                  "
                                        ),
                                        _vm._.isObject(_vm.group.updatedBy)
                                          ? _c("div", [
                                              _c("b", [_vm._v(" by: ")]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._.get(
                                                      _vm.group,
                                                      "updatedBy.emailAddress",
                                                      ""
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f706cc7", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f706cc7","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/Admin/Group.vue
// module id = 1917
// module chunks = 0